import { IconButton } from '@upmc/ims.component-library';
import HomeIcon from '@mui/icons-material/Home';
import { useHistory } from 'react-router-dom';
import { Tooltip } from '../../UI/MDC/Tooltip/Tooltip';
import { CONTENT_ALIGNMENT } from '../../UI/MDC/Tooltip/_types';
import { CSS_CLASSES } from '../_constants';
import classes from './Icon.module.scss';

const BackToHomeIcon = ({ align = CONTENT_ALIGNMENT.BOTTOM }) => {
	const history = useHistory();

	return (
		<>
			<Tooltip align={align} content='Home'>
				<IconButton
					size='large'
					aria-label='home'
					color={'inherit'}
					className={classes[CSS_CLASSES.ICON]}
					id='icon--home'
					onClick={() => history.push('/index.html')}
				>
					<HomeIcon />
				</IconButton>
			</Tooltip>
		</>
	);
};

export default BackToHomeIcon;
